module.exports = __webpack_public_path__ + "static/media/IMG_1407.1a6fb135.JPG";